import { P0, S, abs, arc, fillAt, max, sq } from '../../geometry';

export const crab = {
  name: 'Crab',
  colors: ['#E5484D', '#C46A3E'],
  draw(m, t) {
    let gL = 40 + 8 * S(t * 2),
      gR = 40 + 8 * S(t * 2 + 1),
      lift = [0, 0],
      spread = 0,
      sh = 0,
      pose = P0();
    if (m === 'happy') {
      gL = 40 + 30 * S(t * 14);
      gR = 40 + 30 * S(t * 14 + 1);
      lift = [6 * abs(S(t * 6)), 6 * abs(S(t * 6))];
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: the claws keep snipping in turn while it shuffles side to side.
    if (m === 'thinking') {
      gL = 4 + 66 * max(0, S(t * 5));
      gR = 4 + 66 * max(0, -S(t * 5));
      pose.tx = 3.5 * S(t * 1.6);
      sh = S(t * 6);
      lift = [2 * S(t * 5), -2 * S(t * 5)];
    }
    if (m === 'talking') gL = gR = 20 + 35 * max(0, S(t * 10));
    if (m === 'surprised') {
      gL = gR = 75;
      lift = [9, 9];
      spread = 5;
      pose.ty = -2;
    }
    if (m === 'paused') {
      gL = gR = 0;
      lift = [-12, -12];
      spread = -3;
      pose.ty = 2;
      pose.sy = 0.94;
    }
    const claw = (dir) => {
      const cxy = [50 + dir * (32 + spread), 31 - lift[dir < 0 ? 0 : 1]],
        md = dir < 0 ? -55 : -125,
        g = dir < 0 ? gL : gR;
      return {
        arm: [
          [50 + dir * 20, 53],
          [50 + dir * 28, 45],
          [cxy[0], cxy[1] + 4],
        ],
        body: [
          cxy,
          ...arc(cxy[0], cxy[1], 8.5, md + g / 2, md + 360 - g / 2, 16),
          cxy,
        ],
      };
    };
    const L = claw(-1),
      Rt = claw(1);
    const leg = (dir, k) => {
      const x0 = 50 + dir * (17 + k * 6),
        y0 = 72 - k * 3,
        s = (k ? 1 : -1) * sh * dir;
      return [
        [x0, y0],
        [x0 + dir * 9, y0 + 4 + s],
        [x0 + dir * 11, y0 + 11 + s],
      ];
    };
    return {
      strokes: [
        { c: 'b', pts: leg(-1, 0) },
        { c: 'b', pts: leg(-1, 1) },
        { c: 'b', pts: leg(1, 0) },
        { c: 'b', pts: leg(1, 1) },
        { c: 'a', pts: L.arm },
        { c: 'a', pts: Rt.arm },
        { c: 'a', pts: L.body, sharp: true, n: 40 },
        { c: 'a', pts: Rt.body, sharp: true, n: 40 },
        { c: 'a', pts: sq(50, 63, 27, 15, 2.4), n: 30 },
      ],
      eyes: { x: 50, y: 61 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 6, 7, 8),
};
